import React, { useState, useEffect } from "react";
import Modal from "react-modal";

const customStyles = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		padding: "0px",
		borderRadius: "0px",
	},
};

const MembersPage = () => {
	const [modalIsOpen, setIsOpen] = React.useState(false);
	const [image, setImage] = useState("");

	function openModal() {
		setIsOpen(true);
	}
	function closeModal() {
		setIsOpen(false);
	}

	useEffect(() => {
		if (document) {
			document.body.style.overflow = modalIsOpen ? "hidden" : "auto";
		}
	}, [modalIsOpen]);
	return (
		<React.Fragment>
			<h3 className="footer-title color-red-bat-home fw-500 mt-20 mb-20">
				BAT ORGANIZATION
			</h3>
			<div className="d-flex justify-content-center mb-50 bg-flower-img">
				<div className="bat-mebers-page-images-group-layout">
					<div className="bat-mebers-page-images-group">
						{[1, 2, 3, 4]?.map((item, index) => (
							<img
								key={index}
								src={`/assets/images/bat-img/bat-members-image${item}.jpg`}
								title="BAT Members Page Images"
								className="cursor-pointer"
								onClick={() => {
									setImage(
										`/assets/images/bat-img/bat-members-image${item}.jpg`,
									);
									setIsOpen(true);
								}}
							/>
						))}
					</div>
				</div>
			</div>
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={closeModal}
				style={customStyles}
				contentLabel="Example Modal"
			>
				<img src={image} className="BAT Members Page Images" />
			</Modal>
		</React.Fragment>
	);
};

export default MembersPage;
